import { render, staticRenderFns } from "./reisen-metadata-view.vue?vue&type=template&id=412caee4"
import script from "./reisen-metadata-view.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports